// Config object to be passed to Msal on creation
export const bicsConfig = {
    apiUrl: process.env.REACT_APP_API_URL,
    environment: process.env.REACT_APP_ENVIRONMENT
  };
  
  